import React from 'react';
import { TitleContentRow } from 'components/unique/careerDetail/titleContentRow';
import { DescriptionList } from 'components/unique/careerDetail/descriptionList';

const labels = [
  '企業名',
  '設立年月',
  '本社所在地',
  '資本金',
  '従業員数',
];

const contents = [
  '<p>株式会社フォーデジット</p>',
  '<p>2001年7月</p>',
  '<p>東京都港区赤坂8-5-32 田中駒ビル2F/3F</p>',
  '<p>45,625,000円</p>',
  '<p>179名</p>',
];

export const CareerDetailCompanyOverview = () => {
  return (
    <TitleContentRow titleEn="Company\nOverview" titleJa="企業情報">
      <DescriptionList labels={labels} contents={contents} />
    </TitleContentRow>
  );
};
